import {getFileList} from "@/components/fileCtl/api/file";
import {QueryCommand} from "xmgoing-server";

/**
 * 加载附件列表集合
 * @param businessId
 */
export const loadFileList = async function (businessId: string, backFun: Function) {
  if((businessId+'').indexOf("/api/pe-attachment")>=0){
    return;
  }
  if (businessId == null || businessId === "") {
    return;
  }
  if((businessId+'').length<=10){
    return;
  }
  const res = await getFileList(businessId);
  backFun && backFun(res);
};
/**
 * 根据附件id 获取附件信息
 * @param fileId
 */
export const loadFileByFileId=function (fileId,backFun){
  const queryCommand = new QueryCommand({
    url:`/api/pe-attachment/attachment/detail`,
    method:'GET'
  });
  queryCommand.executeQueryPromise({params:{fileId}}).then((res:any)=>{
    backFun&&backFun(res);
  });
}
